import type { FaireReviewEntity } from "../../entity_types/review";

// Real brand-level review, pulled from Sweet Wink's live Faire brand page
// reviews carousel (not tied to a single product) — verbatim reviewer
// name/location/text/date. Purchased-product thumbnails: the review's real
// source photos aren't individually resolvable from the page capture, so
// this pairs it with a real 10-item tutu + hair-accessories set (the exact
// products the review text calls out) already imported into entity-db,
// rather than inventing placeholder images.
export const review_sw9: FaireReviewEntity = {
  token: "review_sw9",
  type: "review",
  brandName: "Sweet Wink",
  brandToken: "b_gro99lye",
  reviewerName: "Megan",
  reviewerLocation: "Chicago, IL, United States",
  stars: 5,
  reviewText:
    "The cutest line and best quality. The shipping and response time is extremely fast. The tutus are one our best-selling items for girls and they have the cutest matching hair accessories. A must have for a children's boutique.",
  reviewDate: "Jan 22, 2026",
  reviewType: "brand",
  purchasedProductTokens: [
    "p_rkt6sz2etj",
    "p_s46e7wm4wv",
    "p_f8wqg39g46",
    "p_jvkgzpkqkg",
    "p_rmqsym6mvr",
    "p_2bwau32gtz",
    "p_44tn3kjac3",
    "p_hm45ntumx3",
    "p_ju4cgcq65q",
    "p_4k7nd38ket",
  ],
  meta: {
    source: "api",
    importedAt: "2026-08-12T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
